import * as PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import './index.css';
import { Button } from '@mui/material';
import { ReactComponent as Dashboard } from '../../assets/sideBar/dashboard.svg';
import { ReactComponent as Live } from '../../assets/sideBar/live.svg';
import { ReactComponent as InteractiveVideos } from '../../assets/sideBar/interactive.svg';
import { ReactComponent as Campaign } from '../../assets/sideBar/new_campaign_icon.svg';
import { ReactComponent as Channel } from '../../assets/sideBar/channel.svg';
import { ReactComponent as Contracts } from '../../assets/sideBar/new_contract_icon.svg';
import { ReactComponent as LiveStream } from '../../assets/sideBar/live_stream.svg';
import { ReactComponent as Destinations } from '../../assets/sideBar/destinations.svg';
import { ReactComponent as MediaNode } from '../../assets/sideBar/mediaNode.svg';
import { ReactComponent as PrivacyPolicy } from '../../assets/sideBar/privacy_policy_icon.svg';
import variables from '../../utils/variables';
import withRouter from '../../components/WithRouter';
import { fetchMediaNodeDetails, fetchMediaNodeProfileDetails } from '../../actions/mediaNodes';
import { fetchLiveStreams, fetchLiveStreamStatus, setInputStreamKey, setInputStreamUrl, setLiveStreamDetails } from '../../actions/mediaNodes/liveStream';
import { createSocketConnection, setMediaNodePageActive } from '../../actions/mediaNodes/socket';

const tabs = [{
    path: '/dashboard',
}, {
    path: '/library',
}, {
    path: '/campaign',
}, {
    path: '/channel',
}, {
    path: '/interactive-videos',
}, {
    path: '/contracts',
}, {
    path: '/mediaNode',
}, {
    path: '/streams',
}, {
    path: '/destinations',
}, {
    path: '/privacyPolicy',
}];

const Sidebar = (props) => {
    const handleClick = (url) => {
        if (url === '/privacyPolicy') {
            window.open(url, '_blank');
        } else {
            props.router.navigate(url);
        }
    };

    // const handleStream = (url) => {
    //     const mediaNodeID = localStorage.getItem('active_of_studio_media_node');
    //     if (mediaNodeID && (mediaNodeID !== props.mediaNodeID || !Object.keys(props.mediaNodeDetails).length)) {
    //         props.fetchMediaNodeDetails(mediaNodeID, (result) => {
    //             if (result) {
    //                 handleFetchStreamDetails(mediaNodeID, result, url);
    //             }
    //         });
    //     } else if (mediaNodeID && Object.keys(props.mediaNodeDetails).length) {
    //         props.router.navigate(`/mediaNode/${mediaNodeID}`);
    //     } else {
    //         props.router.navigate(url);
    //     }
    // };

    // const handleFetchStreamDetails = (mediaNodeID, nodeDetails, url) => {
    //     props.fetchMediaNodeProfileDetails(nodeDetails && nodeDetails.url, nodeDetails && nodeDetails._id);
    //     props.fetchLiveStreams((result, error) => {
    //         if (error) {
    //             if (localStorage.getItem(`acToken_of_studio_media_node_${nodeDetails && nodeDetails._id}`)) {
    //                 localStorage.removeItem(`acToken_of_studio_media_node_${nodeDetails && nodeDetails._id}`);
    //             }
    //             if (localStorage.getItem(`rfToken_of_studio_media_node_${nodeDetails && nodeDetails._id}`)) {
    //                 localStorage.removeItem(`rfToken_of_studio_media_node_${nodeDetails && nodeDetails._id}`);
    //             }
    //             if (localStorage.getItem('active_of_studio_media_node')) {
    //                 localStorage.removeItem('active_of_studio_media_node');
    //             }
    //             props.router.navigate(url);
    //             return;
    //         }
    //         if (result && result.length && result[0]) {
    //             props.setLiveStreamDetails(result[0]);
    //             props.fetchLiveStreamStatus(nodeDetails && nodeDetails.url, result[0]._id, nodeDetails && nodeDetails._id);
    //             // props.fetchLiveStreamWatchUrl(nodeDetails && nodeDetails.url, result[0]._id, nodeDetails && nodeDetails._id);
    //             props.setMediaNodePageActive(true);
    //             props.createSocketConnection(nodeDetails && nodeDetails.url,
    //                 localStorage.getItem('address_of_studio'),
    //                 result[0] && result[0].media_space && result[0].media_space._id,
    //                 result[0]._id,
    //                 (result) => {
    //                     if (result && result.broadcast_status && result.broadcast_status.status && result.broadcast_status.status === 'active') {
    //                         props.setInputStreamUrl(result[0] && result[0].configuration && result[0].configuration.broadcast_config && result[0].configuration.broadcast_config.stream_url);
    //                         props.setInputStreamKey(result[0] && result[0].configuration && result[0].configuration.broadcast_config && result[0].configuration.broadcast_config.stream_key);
    //                     } else if (result && result.live_feed_status && result.live_feed_status.status && result.live_feed_status.status === 'active') {
    //                         props.setInputStreamUrl(result[0] && result[0].configuration && result[0].configuration.live_feed_status && result[0].configuration.live_feed_status.stream_url);
    //                         props.setInputStreamKey(result[0] && result[0].configuration && result[0].configuration.live_feed_status && result[0].configuration.live_feed_status.stream_key);
    //                     }
    //                 });
    //             props.router.navigate(`/mediaNode/${mediaNodeID}`);
    //         }
    //     });
    // };

    const path = props.router && props.router.location && props.router.location.pathname;
    // let mediaNodeActive = false;
    const show = props.router && props.router.location && props.router.location.pathname &&
        tabs.find((value) => {
            // if (props.router.location.pathname.split('/')[1] === value.path.split('/')[1] && props.router.location.pathname.split('/').length > 2 && props.router.location.pathname.split('/')[1] === 'mediaNode') {
            //     mediaNodeActive = true;
            // }
            return props.router.location.pathname.split('/')[1] === value.path.split('/')[1];
        });

    return (
        <div className={`side_bar ${path && (path.includes('channel/settings') || path.includes('/publish') || path.includes('/interactive-videos/') || path.includes('/streams/')) ? 'hide_sidebar' : ''}`}>
            <Button
                aria-label={variables[props.lang].dashboard}
                className={(path === '/dashboard') || (show && show.path === '/dashboard') ? 'active_tab ' : ''}
                title={variables[props.lang].dashboard}
                onClick={() => handleClick('/dashboard')}>
                <Dashboard/>
                {variables[props.lang].dashboard}
            </Button>
            <Button
                aria-label={variables[props.lang]['asset_library']}
                className={(path === '/library') || (show && show.path === '/library') ? 'active_tab ' : ''}
                title={variables[props.lang]['asset_library']}
                onClick={() => handleClick('/library')}>
                <Live/>
                {variables[props.lang]['asset_library']}
            </Button>
            <Button
                aria-label={variables[props.lang].channel}
                className={(path === '/channel') || (show && show.path === '/channel') ? 'active_tab ' : ''}
                title={variables[props.lang].channel}
                onClick={() => handleClick('/channel')}>
                <Channel/>
                {variables[props.lang].channels}
            </Button>
            <Button
                aria-label={variables[props.lang].videos}
                className={(path === '/interactive-videos') || (show && show.path === '/interactive-videos') ? 'active_tab' : ''}
                title={variables[props.lang].videos}
                onClick={() => handleClick('/interactive-videos')}>
                <InteractiveVideos/>
                {variables[props.lang].videos}
            </Button>
            <Button
                aria-label="Media Node"
                className={(path === '/streams') || (show && show.path === '/streams') ? 'active_tab' : ''}
                title="Media Node"
                onClick={() => handleClick('/streams')}>
                <LiveStream/>
                Streams
            </Button>
            <Button
                aria-label="Live Stream Destinations"
                className={(path === '/destinations') || (show && show.path === '/destinations') ? 'active_tab' : ''}
                title="Live Stream Destinations"
                onClick={() => handleClick('/destinations')}>
                <Destinations/>
                Destinations
            </Button>
            <Button
                aria-label={variables[props.lang].campaigns}
                className={(path === '/campaign') || (show && show.path === '/campaign') ? 'active_tab' : ''}
                title={variables[props.lang].campaigns}
                onClick={() => handleClick('/campaign')}>
                <Campaign/>
                {variables[props.lang].campaigns}
            </Button>
            {/* <Button */}
            {/*    aria-label={variables[props.lang].campaign} */}
            {/*    className={(path === '/campaign') || (show && show.path === '/campaign') */}
            {/*        ? 'active_tab ' : ''} */}
            {/*    title={variables[props.lang].campaign} */}
            {/*    onClick={() => handleClick('/campaign')}> */}
            {/*    <Campaign/> */}
            {/*    {variables[props.lang].campaign} */}
            {/* </Button> */}
            <Button
                aria-label={variables[props.lang].contracts}
                className={(path === '/contracts') || (show && show.path === '/contracts') ? 'active_tab ' : ''}
                title={variables[props.lang].contracts}
                onClick={() => handleClick('/contracts')}>
                <Contracts/>
                {variables[props.lang].contracts}
            </Button>
            <Button
                aria-label="Media Node"
                className={(path === '/mediaNode') || (show && show.path === '/mediaNode') ? 'active_tab ' : ''}
                title="Media Node"
                onClick={() => handleClick('/mediaNode')}>
                <MediaNode/>
                Media Nodes
            </Button>
            <div className="pp_button">
                <Button
                    aria-label="Privacy Policy"
                    className={(path === '/privacyPolicy') || (show && show.path === '/privacyPolicy') ? 'active_tab ' : ''}
                    title="Privacy Policy"
                    onClick={() => handleClick('/privacyPolicy')}>
                    <PrivacyPolicy/>
                    {variables[props.lang].privacy_policy}
                </Button>
            </div>
        </div>
    );
};

Sidebar.propTypes = {
    createSocketConnection: PropTypes.func.isRequired,
    fetchLiveStreamStatus: PropTypes.func.isRequired,
    fetchLiveStreams: PropTypes.func.isRequired,
    fetchMediaNodeDetails: PropTypes.func.isRequired,
    fetchMediaNodeProfileDetails: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    mediaNodeDetails: PropTypes.object.isRequired,
    setInputStreamKey: PropTypes.func.isRequired,
    setInputStreamUrl: PropTypes.func.isRequired,
    setLiveStreamDetails: PropTypes.func.isRequired,
    setMediaNodePageActive: PropTypes.func.isRequired,
    mediaNodeID: PropTypes.string,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }).isRequired,
        params: PropTypes.shape({
            nodeID: PropTypes.string.isRequired,
        }).isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        mediaNodeDetails: state.mediaNode.mediaNodeDetails.value,
        mediaNodeID: state.mediaNode.mediaNodeDetails.nodeID,
    };
};

const actionToProps = {
    fetchMediaNodeDetails,
    fetchMediaNodeProfileDetails,
    fetchLiveStreams,
    setLiveStreamDetails,
    fetchLiveStreamStatus,
    setMediaNodePageActive,
    createSocketConnection,
    setInputStreamUrl,
    setInputStreamKey,
};

export default withRouter(connect(stateToProps, actionToProps)(Sidebar));
